// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"29beead9","882":"621a5e9c","900":"904f659b","941":"e47a8dfa"}[chunkId] + ".chunk.js";
};